import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { DeleteDesignFolderDocument } from './delete.generated';

export const useDeleteDesignFolder = (
  options: ApiOptions<typeof DeleteDesignFolderDocument> = {},
) => {
  const { t } = useTranslation();
  return useMutation(DeleteDesignFolderDocument, {
    ...useNotifications(DeleteDesignFolderDocument, {
      failure: t('api.design_folders.delete_error'),
      success: t('api.design_folders.delete_success'),
    }),
    ...options,
  });
};
